import React from 'react';
import './styles/select_list_dropdown';

export default class SelectListDropdown extends React.Component {
  state = {
    open: false,
    selectedValue: null
  };

  updateSelected(value) {
    this.setState({ selectedValue: value });
    this.props.onSelect(value);
    this.toggleOpenClose();
  }

  toggleOpenClose() {
    this.setState({ open: !this.state.open });
  }

  renderOptionsList() {
    return this.props.list.map((format, key) => {
      // TODO: move itemClass out of the generic dropdown component
      let itemClass = (format === 'animated gif' || format === 'mp3/audio' ? 'border-top' : '');
      return (
        <li
          key={key}
          onClick={(event) => this.updateSelected(event.target.innerHTML)}
          className={this.state.selectedValue === format ? itemClass + ' selected' : itemClass}
        >
          {format}
        </li>
      );
    });
  }

  render() {
    let chevronStlye = `float-right fa ${this.state.open ? 'fa-chevron-up' : 'fa-chevron-down'}`;
    let wrapClass = `select-container ${this.props.scroll ? 'scroll' : 'no-scroll'}`;
    return (
      <div className="select-list-dropdown-component">
        <div className="select-dropdown-wrap full">
          <div className="select-dropdown-label">
            {this.props.dropdownLabel}
          </div>
          <div className={wrapClass}>
            <div className="open-close-button" onClick={this.toggleOpenClose.bind(this)}>
              <div className="default-value float-left">
                {this.state.selectedValue || this.props.defaultValue}
              </div>
              <div className={chevronStlye} />
            </div>
            <ul className={this.state.open ? 'dropdown-options open' : 'dropdown-options'}>
              {this.renderOptionsList()}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
